import { QuestionTypeEnum } from '@/models/Question';
import { FillInTheBlankResultBlank } from '@/components/question/view/primitives/correction/FillInTheBlankResultBlank';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { useFillInTheBlankCorrection } from '@/components/question/view/typologies/fill-in-the-blank/useFillInTheBlankCorrection';

export function FillInTheBlankCorrectionView(
  props: QuestionViewPropsFor<QuestionTypeEnum.FILL_IN_THE_BLANK>,
) {
  const { segments } = useFillInTheBlankCorrection(props);

  return (
    <p className="w-full text-lg leading-loose text-base-content whitespace-pre-wrap">
      {segments.map((segment, index) =>
        segment.type === 'text' ? (
          <span key={`text-${index}`}>{segment.value}</span>
        ) : (
          <FillInTheBlankResultBlank
            key={`blank-${segment.index}`}
            segment={segment}
          />
        ),
      )}
    </p>
  );
}
